import api from './api';

const getReferralConfig = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: '/referral/config',
    });

    return response;
  } catch (error) {
    return {
      status: 0,
    };
  }
};

const getReferral = async () => {
  const response = await api({
    method: 'GET',
    url: '/referral',
  });

  return response;
};

const registerReferral = async () => {
  const response = await api({
    method: 'POST',
    url: '/referral',
  });

  return response;
};

const checkUserEligibility = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: '/referral/eligibility',
    });

    return response;
  } catch (error) {
    return {
      status: 0,
    };
  }
};

const applyReferral = async (referralCode) => {
  try {
    const response = await api({
      method: 'POST',
      url: '/referral/apply',
      data: {
        referralCode,
      },
    });

    return response;
  } catch (error) {
    return {
      status: 0,
    };
  }
};

const redeemReferral = async (points) => {
  try {
    const response = await api({
      method: 'POST',
      url: '/referral/redeem',
      data: {
        points,
      },
    });

    return response;
  } catch (error) {
    return {
      status: 0,
    };
  }
};

const changeReferralCode = async (referralCode) => {
  try {
    const response = await api({
      method: 'PUT',
      url: '/referral',
      data: {
        referralCode,
      },
    });

    return response;
  } catch (error) {
    return {
      status: 0,
      code: error.response?.data?.code,
    };
  }
};

const getRevenueRewardConfig = async () => {
  const response = await api({
    method: 'GET',
    url: '/referral/revenue-reward/config',
  });

  return response;
};

export {
  getReferralConfig,
  getReferral,
  registerReferral,
  applyReferral,
  redeemReferral,
  checkUserEligibility,
  changeReferralCode,
  getRevenueRewardConfig,
};
